// extracted by mini-css-extract-plugin
export default {"GroupLayoutWrapper":"FflQoEz3"};